import React, { useContext } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router';
import { Container, Flex } from './design-system';
import styled from 'styled-components';
import { Toaster } from 'sonner';
import { Session } from './contexts/sessionContext';
import AuthedRoutes from './routes/authed';
import PublicRoutes from './routes/public';

const MainContainer = styled(Container)`
  margin: 0;
  padding: 0;
  max-width: none;
`;

const StyledFlex = styled(Flex)`
  min-height: 100vh;
`;

const App = () => {
  const { state } = useContext(Session);

  return (
    <BrowserRouter>
      <MainContainer>
        <StyledFlex>
          {state.user ? (
            <Routes>
              <Route
                path="/*"
                element={
                  <AuthedRoutes
                    user={state.user}
                    // This makes it so that when you are logged out and click a link, it will take you where you wanted to go after you log-in.
                    route_to={
                      state.originalPath !== window.location.pathname
                        ? state.originalPath
                        : null
                    }
                  />
                }
              />
            </Routes>
          ) : (
            <Routes>
              <Route path="/*" element={<PublicRoutes />} />
            </Routes>
          )}
          <Toaster
            position="top-right"
            toastOptions={{
              style: { borderRadius: 5, fontWeight: 600 },
            }}
            richColors
          />
        </StyledFlex>
      </MainContainer>
    </BrowserRouter>
  );
};

export default App;
